import gql from 'graphql-tag';

export default gql`
  mutation EditQuickMeal($input: DailyTrackerEditQuickMealInputType!) {
    dailyTracker {
      editQuickMeal(input: $input) {
        ... on DailyTrackerEditQuickMealSuccess {
          meal {
            id
            isQuickMeal
          }
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
        ... on UnauthorizedException {
          code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
      }
    }
  }
`;
